import { LessonType } from "../../../Types/Courses";

export interface LessonFormState {
  id?: number;
  title: string;
  type: LessonType;
  content: string;
  video_url: string;
  duration_minutes: number | "";
  exercise_id: number | "";
}

export const defaultLessonForm: LessonFormState = {
  title: "",
  type: "text",
  content: "",
  video_url: "",
  duration_minutes: "",
  exercise_id: "",
};
